import {
    CommunicationContentModelSummaryModel
} from '../../../../communication/content-model/api/entity/communicationContentModelSummary.model';
import {WithoutSummaryModel} from '../../../../common/entity/dto/plain/withoutSummary.model';
import {
    CommunicationContentModelModel
} from '../../../../communication/content-model/api/entity/communicationContentModel.model';

export class ReportCommunicationContentModel extends WithoutSummaryModel {
    content: string;
    contentModel: CommunicationContentModelModel;
}
